export const setUsersList = () => {
  window.location.hash = `/users`
  return {
    type: 'SET_LAYOUT',
    route: 'USERS_LIST',
    tab: null,
    data: {},
  };
}

export const setConsentsList = () => {
  window.location.hash = `/consents`
  return {
    type: 'SET_LAYOUT',
    route: 'CONSENTS_LIST',
    tab: null,
    data: {},
  };
}


// WEBPACK FOOTER //
// ./src/actions/layout.js